module.exports = __webpack_public_path__ + "media/images/flowchart_320-4a2647074584513c397d004d814c5a6d.svg";